import { type FunctionComponent } from 'react';
import JumpBackButton from './JumpBackButton';
import PickTime from '../../PickTime/PickTime';
import { Page, type VesselViewModel } from '../../../types';
import { type Timestamp } from '../../../services/Timestamp';
import RecenterButton from '../../Scrubber/components/RecenterButton';
import ShareLink from '../../Map/components/ShareLink/ShareLink';
import IncorrectInformation from '../../Map/components/IncorrectInformation/IncorrectInformation';

interface Props {
  vessel: VesselViewModel;
  timestamp: Timestamp;
  timezone: string;
  operation: string;
  isTripsPanelOpen: boolean;
  setTimestamp: (timestamp: Timestamp) => void;
  setStartTimestamp: (timestamp: Timestamp) => void;
  isLockedOnTarget: boolean;
  onTargetLock: (mmsi: string) => void;
}

const LivePanelControls: FunctionComponent<Props> = ({
  vessel,
  isLockedOnTarget,
  timestamp,
  timezone,
  operation,
  isTripsPanelOpen,
  onTargetLock,
  setTimestamp,
  setStartTimestamp,
}) => {
  return (
    <div className="scrubber-controls-container">
      <JumpBackButton
        timestamp={timestamp}
        setTimestamp={setTimestamp}
        setStartTimestamp={setStartTimestamp}
        operation={operation}
      />
      <PickTime
        isTripsPanelOpen={isTripsPanelOpen}
        operation={operation}
        page={Page.Liveview}
        timestamp={timestamp}
        timezone={timezone}
        vessel={vessel}
        setTimestamp={setTimestamp}
        setStartTimestamp={setStartTimestamp}
      />
      <RecenterButton vessel={vessel} isLockedOnTarget={isLockedOnTarget} onTargetLock={onTargetLock} />
      <ShareLink
        timestamp={timestamp}
        startTimestamp={null}
        targetVesselMmsi={vessel?.mmsi}
        page={Page.Liveview}
        timezone={timezone}
      />
      <IncorrectInformation page={Page.Liveview} vessel={vessel} timestamp={timestamp} timezone={timezone} />
    </div>
  );
};

export default LivePanelControls;
